import { CloseEndedQuestion, Content, Exercise, Option } from '@ilteducation/exercise-service-types';
import { ref } from 'vue';

const drafts = ref<Partial<Exercise>[]>([]);

export const addExercise = (exercise: Partial<Exercise>) => drafts.value.push(exercise);
export const getExercise = (id: string) => drafts.value.find((exercise) => exercise.id === id);
export const addContent = (exerciseId: string, content: Content) => {
  const exercise = getExercise(exerciseId);
  if (exercise) {
    exercise.content?.push(content);
  }
};
export const getContentByAttribute = (exerciseId: string, attrName: string, attrValue: any) => {
  const exercise = getExercise(exerciseId);
  if (!exercise) {
    return undefined;
  }
  return exercise.content?.find((content) => (content as Record<string, any>)[attrName] === attrValue) as Content;
};

const parseQuiz = (tableRows: any[]) => {
  let currentQuizId: string;
  let currentQuestion: string;
  let optionId = 0;
  let currentQuestionContent: Content | undefined;
  tableRows.forEach((tr) => {
    const rawData = tr.querySelectorAll('td');

    const quizNumber = rawData[0].innerText;

    if (quizNumber && !getExercise(quizNumber)) {
      // create a new quiz
      currentQuizId = quizNumber;
      addExercise({
        id: currentQuizId,
        type: 'quiz',
        title: `Quiz ${currentQuizId}`,
        content: [],
      });
    }

    const contentQuestion = rawData[1].innerText;
    if (contentQuestion) {
      currentQuestion = contentQuestion;
      currentQuestionContent = {
        phrase: contentQuestion,
        type: 'closed-question',
        options: [] as Option[],
      } as CloseEndedQuestion;
      addContent(currentQuizId, currentQuestionContent);
      optionId = 0;
    }

    const questionAnswer = rawData[2].innerText;
    if (questionAnswer && currentQuestionContent) {
      (currentQuestionContent as CloseEndedQuestion).options.push({
        id: optionId.toString(),
        value: questionAnswer,
      });
    }

    const questionAnswerCorrect = rawData[3].innerText;
    if (questionAnswerCorrect) {
      (currentQuestionContent as CloseEndedQuestion).answer = optionId.toString();
    }
    optionId += 1;
  });
  const cleanExercises = drafts.value.filter((exercise) => {
    delete exercise.id;
    return true;
  });
  drafts.value = [];
  return cleanExercises;
};

export default parseQuiz;
